import filterComputedProperties from './filterComputedProperties';
import computeProperty from './computeProperty';

export default function computeProperties(state, host) {
	const computed = filterComputedProperties(host);

	for (const k in computed) state.properties[k] = computeProperty(k, computed[k], {state, host});

	return state;
}
